export const setPageTitle = pageTitle => {
  document.title = pageTitle ? `DevSecOps, Inc - ${pageTitle}` : 'DevSecOps, Inc';
};
